export const getGclid = () => {
    try {
        if (typeof localStorage === 'undefined') return;
        const _gcl_ls = localStorage.getItem('_gcl_ls');
        const parseData = JSON.parse(_gcl_ls || '{}');
        return parseData?.gclid?.value?.value;
    } catch (error) {
        console.log('', (error as Error).message);
        return;
    }
};
